import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPackageEdit: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="package-edit,delivery"><path d="M11.75 20.25H3.75V3.75H8.75M8.75 3.75H15.25M8.75 3.75V9.25H15.25V3.75M15.25 3.75H20.25V10.75M14.75 17.9166V20.2499H17.0833L20.8333 16.4999C21.4777 15.8556 21.4777 14.8109 20.8333 14.1666C20.189 13.5223 19.1443 13.5223 18.5 14.1666L14.75 17.9166Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPackageEdit;
